module.exports = __webpack_public_path__ + "img/management-philosophy-2.51713e56.png";